import { render } from "./ownerDetail.vue?vue&type=template&id=027b97b4&scoped=true&ts=true"
import script from "./ownerDetail.vue?vue&type=script&lang=ts"
export * from "./ownerDetail.vue?vue&type=script&lang=ts"

import "./ownerDetail.vue?vue&type=style&index=0&id=027b97b4&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027b97b4"]])

export default __exports__